import React from 'react';
import { ProductItem } from 'components';
import { useNavigate } from 'react-router-dom';
import { encrypt } from 'utils/Crypto';
import './MyItemList.css';

const MyItemList = ({ items }) => {
  const navigate = useNavigate();

  return (
    <div>
      <div
        className="wrap"
        style={{
          marginTop: 32,
          //display: screenSize >= 768 ? 'grid' : 'flex', // Grid 레이아웃 사용
          //gridTemplateColumns: 'repeat(5, 1fr)', // 5개의 고정된 열
          //gap: screenSize >= 768 ? '20px' : '10px', // 항목 간의 간격
          //justifyItems: 'center', // 각 아이템을 중앙 정렬
          //flexWrap: 'wrap',
        }}
      >
        {items?.map(
          (item) =>
            item && (
              <div
                className="item"
                key={`wish-${item?.key}`}
                style={{
                  //width: screenSize >= 400 ? 158 : 130, // 고정된 너비
                  cursor: 'pointer',
                }}
                onClick={() =>
                  navigate(
                    `/products/${encodeURIComponent(encrypt(item?.productKey))}`
                  )
                }
              >
                <ProductItem.Image
                  src={item?.src}
                  title={item?.title}
                  hovered={false}
                  style={{
                    marginBottom: 8,
                    //height: 196,
                  }}
                />
                <ProductItem.Title
                  title={item?.title}
                  style={{
                    fontSize: 15,
                    fontWeight: 400,
                    overflow: 'visible',
                    textOverflow: 'inherit',
                    webkitBoxOrient: 'unset',
                  }}
                />
                <ProductItem.Price
                  unit={'원'}
                  price={item?.price}
                  discount={item?.discount}
                  type={item?.type}
                  style={{
                    fontSize: 15,
                    fontWeight: 700,
                  }}
                />
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default MyItemList;
